import React from 'react';
import solid from '@fortawesome/fontawesome-free-solid';



function Footer() {
return(
      <div className="hero-foot ">
          <div className="container has-text-centered">
            <p>Made with
             <span className="icon">
                <i className="fa fa-heart"></i>
              </span> by Alex
            </p>
          </div>
      </div>
  )
}
export default Footer;








// WEBPACK FOOTER //
// ./src/components/Footer.js